// src/Dashboard/pages/user/Inscription/components/UsefulDocumentsPanel.jsx

import React, { useState } from "react";
import {
  FaChevronDown,
  FaChevronUp,
  FaFileDownload,
  FaFolderOpen,
} from "react-icons/fa";

import { openInNewTab, toAbsoluteUrl } from "../utils/inscriptionUtils";

export default function UsefulDocumentsPanel({ segments }) {
  const [open, setOpen] = useState({});

  const toggle = (id) => {
    setOpen((previous) => ({
      ...previous,
      [id]: !previous[id],
    }));
  };

  if (!Array.isArray(segments) || segments.length === 0) {
    return null;
  }

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="border-b border-slate-200 bg-slate-50 px-5 py-5 dark:border-slate-800 dark:bg-slate-900/60 sm:px-6">
        <div className="flex items-start gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-[#013E8E] shadow-sm ring-1 ring-slate-200 dark:bg-slate-950 dark:text-indigo-300 dark:ring-slate-700">
            <FaFolderOpen />
          </span>

          <div>
            <h2 className="text-lg font-bold text-slate-900 dark:text-white">
              Informations et documents utiles
            </h2>

            <p className="mt-1 text-sm leading-6 text-slate-500 dark:text-slate-400">
              Retrouvez ici les documents à télécharger, informations de saison,
              consignes du club et formulaires nécessaires à l’inscription.
            </p>
          </div>
        </div>
      </div>

      <div className="divide-y divide-slate-200 dark:divide-slate-800">
        {segments.map((segment) => {
          const isOpen = !!open[segment.id];

          return (
            <article key={segment.id}>
              <button
                type="button"
                onClick={() => toggle(segment.id)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-slate-50 dark:hover:bg-slate-900/70 sm:px-6"
              >
                <span className="min-w-0">
                  <span className="block truncate text-sm font-bold text-slate-900 dark:text-white">
                    {segment.segment_name}
                  </span>

                  <span className="mt-1 block text-xs text-slate-500 dark:text-slate-400">
                    {segment.fichiers?.length || 0} document
                    {(segment.fichiers?.length || 0) > 1 ? "s" : ""} associé
                    {(segment.fichiers?.length || 0) > 1 ? "s" : ""}
                  </span>
                </span>

                <span className="text-slate-500 dark:text-slate-400">
                  {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </button>

              {isOpen && (
                <div className="px-5 pb-5 sm:px-6">
                  <div
                    className="prose prose-sm max-w-none dark:prose-invert prose-headings:mt-0 prose-p:my-2"
                    dangerouslySetInnerHTML={{
                      __html: segment.segment_content || "",
                    }}
                  />

                  {segment.fichiers?.length > 0 && (
                    <div className="mt-4 flex flex-wrap gap-2">
                      {segment.fichiers.map((file) => (
                        <button
                          key={file.id}
                          type="button"
                          onClick={() => openInNewTab(toAbsoluteUrl(file.lien_fichier))}
                          className="inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-2 text-sm font-bold text-white transition hover:bg-indigo-800"
                          title={file.detail_fichier || file.nom_fichier}
                        >
                          <FaFileDownload />
                          {file.nom_fichier}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}